// extracted by mini-css-extract-plugin
export var addressFields = "_hu-0";
export var animationContainer = "_hu-1";
export var footer = "_hu-2";
export var lineItems = "_hu-3";
export var modalContent = "_hu-4";
export var orderName = "_hu-5";
export var strong = "_hu-6";
export var warning = "_hu-7";